import * as React from 'react';
import {observer} from "mobx-react";
import styles from "./styles/SchoolBlocksHeader.module.scss";
import dynamic from "next/dynamic";
import {useStores} from "../../stores/useStores";

const SimpleAndFloating = dynamic(() => import("./SchoolBlocksHeaderThemes/SimpleAndFloating"));

const SchoolBlocksHeader: React.FC<{
    hideNavigation?: boolean,
    hideLoginButton?: boolean,
    mainUrl: string,
    preventTabbing: boolean
}> = observer(props => {
    const {styleStore, modalStore, organizationStore, interfaceStore} = useStores();

    function openLoginModal() {
        modalStore.addModal({
            type: 'login',
            id: 'login-modal',
        })
    }

    function toggleUserMenu() {
        interfaceStore.toggleUserMenu();
    }

    const hideLoginButton = organizationStore.organization.json_data?.settings?.appearance?.hideLoginButton || props.hideLoginButton;

    return <div className={styles.centerContent}>
        <SimpleAndFloating
            toggleUserMenu={toggleUserMenu}
            openLoginModal={openLoginModal}
            mainUrl={props.mainUrl}
            hideNavigation={props.hideNavigation}
            hideLoginButton={hideLoginButton}
            preventTabbing={props.preventTabbing}
        />
    </div>
})

export default SchoolBlocksHeader;
